import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../../../i18n/LanguageContext";

const Stats = () => {
  const { t } = useLanguage();
  const stats = t.stats.items;

  return (
    <section
      aria-label={t.stats.label}
      className="font-inter relative z-10 mx-auto mt-24 w-full max-w-4xl px-6 md:mt-32"
    >
      <motion.dl
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-[rgba(67,65,85,0.4)] bg-[rgba(67,65,85,0.4)] md:grid-cols-4"
      >
        {stats.map((stat, i) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="group flex flex-col items-center justify-center bg-[#1a1928] px-4 py-7 transition-colors duration-300 hover:bg-[#201f30]"
          >
            <dd className="bg-gradient-to-r from-indigo-300 to-purple-400 bg-clip-text text-3xl font-black text-transparent md:text-4xl">
              {stat.value}
            </dd>
            <dt className="mt-2 text-center text-xs font-medium uppercase tracking-wider text-[rgba(245,245,245,0.62)]">
              {stat.label}
            </dt>
            <span className="mt-1 text-center text-[11px] text-[rgba(245,245,245,0.32)]">
              {stat.detail}
            </span>
          </motion.div>
        ))}
      </motion.dl>
    </section>
  );
};

export default Stats;
